<template>
    <div>
        <br>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline my-2 my-lg-0">
                    <button type="button" class="btn btn-warning" @click="goToPromotionOtherForm(null)">
                        <icon name="plus"></icon>
                        เพิ่มโปรโมชั่น
                    </button>
                </form>
            </div>
        </nav>
        <div class="table-responsive">
            <table class="table table-bordered">
                <thead>
                <tr>
                    <th>ชื่อโปรโมชั่น</th>
                    <th>สถานะ</th>
                    <th>เซลล์</th>
                    <th>แก้ไข</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="data in promotionOtherList">
                    <td>
                        <template v-if="data.name">{{ data.name }}</template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="data.active">
                            {{ data.active_name }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="data.sale_id" v-for="(seller,index) in data.sales">
                            {{ seller.name }}
                            <span v-if="index != data.sales.length - 1">,</span>
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <a @click="goToPromotionOtherForm(data.id)">
                            <icon name="pencil-alt"></icon>
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <!--<pre class="alert-primary">{{promotionOtherList}}</pre>-->
    </div>
</template>

<script>
import {mapState} from "vuex";

export default {
    name: "promotion-other-list",
    created() {
        this.$store.dispatch('PromotionOther/setPromotionOtherList');
    },
    computed: {
        ...mapState({
            promotionOtherList: state => {
                return state.PromotionOther.promotion_other_list
            }
        })
    },
    methods: {
        goToPromotionOtherForm(id) {
            //console.log(id);
            if (id) {
                this.$store.dispatch("PromotionOther/showPromotionOther", id);
            } else {
                this.$store.dispatch("PromotionOther/clearData");
            }
            this.$router.push("/promotions-other-form");
        }
    }
}
</script>

<style scoped>

</style>
